<template>
  <div class="back-to-top">
    <el-backtop
      :v-bind="$attrs"
      :target="target"
      :bottom="bottom"
      :right="right"
      :visibility-height="visibilityHeight"
    >
      <slot />
    </el-backtop>
    <div
      v-if="preventBtn"
      class="prevent"
      :style="{ right: right + 'px', bottom: bottom + 'px' }"
      @click="handleClick"
    />
  </div>
</template>

<script lang="ts" setup name="BackToTop">
import { ElBacktop } from "element-plus";

defineProps({
  /** 是否关闭默认行为 **/
  preventBtn: {
    type: Boolean,
    default: true
  },
  visibilityHeight: {
    type: Number,
    default: 800
  },
  right: {
    type: Number,
    default: 15
  },
  bottom: {
    type: Number,
    default: 120
  },
  target: {
    type: String,
    default: ".page"
  }
});
const emits = defineEmits(["handleClick"]);

const handleClick = e => {
  e.preventDefault();
  emits("handleClick");
  return null;
};
</script>

<style lang="scss" scoped>
.prevent {
  position: fixed;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 50%;
}
</style>
